// composables/useVueInnerImageZoom.ts
import VueInnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';

export function useVueInnerImageZoom() {
  return VueInnerImageZoom;
}
